/**
 * @name ResponsibilitiesService
 * @description Servicio para la gestión de responsabilidades
 * @author Ricardo Guerra
 */

import axios from 'axios';
import { Environment } from '@config';

// URL Administración Endpoint
const BASE_URL = `${Environment.getCurrent().endpoints.admin}`;

/**
 * Consulta las responsabilidades de un usuario
 * @param {any} request { page, size, filter.id, columns }
 * @return {any} promise
 */
const get = (request) => {
  let columns = request.columns === null ? '' : `&columnas=${request.columns}`;
  let employeeId = request.filter.id ? `&idEmpleado=${request.filter.id}` : '';
  let URL = `${BASE_URL}/Responsabilidad?paginado=${request.page},${request.size}${employeeId}${columns}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Añade una responsabilidad al usuario
 * @param {any} request { Nombre, Peso, IdEmpleado }
 * @return {any} promise
 */
const post = (request) => {
  let admin = request.admin ? '/Admin' : '';
  let URL = `${BASE_URL}/Responsabilidad${admin}`;

  return axios.post(URL, request).then(({ data }) => {
    return data;
  });
};

/**
 * Edita una responsabilidad del usuario
 * @param {any} request { Id, Nombre, Peso, IdEmpleado }
 * @return {any} promise
 */
const put = (request) => {
  let admin = request.admin ? 'Admin/' : '';
  let URL = `${BASE_URL}/Responsabilidad/${admin}${request.Id}`;

  return axios.put(URL, request).then(({ data }) => {
    return data;
  });
};

/**
 * Elimina una responsabilidad del usuario
 * @param {any} request { Id, EmployeeId}
 * @return {any} promise
 */
const _delete = (request) => {
  let admin = request.admin ? 'Admin/' : '';
  let employeeId = request.EmployeeId ? `?idEmpleado=${request.EmployeeId}` : '';
  let URL = `${BASE_URL}/Responsabilidad/${admin}${request.Id}${employeeId}`;

  return axios.delete(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Consulta el estatus de las responsabilidades de un usuario
 * @param {any} request { employeeId }
 * @return {any} promise
 */
const checkStatus = (request) => {
  let employeeId = request ? `?idEmpleado=${request}` : '';
  let URL = `${BASE_URL}/ResponsabilidadEstatus${employeeId}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Modifica el estatus de las responsabilidades de un usuario
 * @param {any} request { Id, IdEmpleado, Comentario }
 * @return {any} promise
 */
const changeStatus = (request) => {
  let admin = request.admin ? '/Admin' : '';
  let URL = `${BASE_URL}/ResponsabilidadEstatus${admin}`;

  return axios.put(URL, request).then(({ data }) => {
    return data;
  });
};

/**
 * Obtiene el listado de avance por colaborador en sus responsabilidades
 * @param {any} request { page, size, filter.IdEmpleado, filter.Id }
 * @return {any} promise
 */
const getProgressReport = (request) => {
  let employeeId = request.filter.IdEmpleado ? `&idEmpleado=${request.filter.IdEmpleado}` : '';
  let id = request.filter.Id ? `&id=${request.filter.Id}` : '';
  let URL = `${BASE_URL}/Responsabilidad/Autorizaciones/Empleado?paginado=${request.page},${request.size}${employeeId}${id}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Obtiene el listado de responsabilidades por colaborador de la estructura
 * @return {any} promise
 */
const getStructureReport = () => {
  let URL = `${BASE_URL}/Responsabilidad/Reporte?esAdmin=false`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

export const ResponsibilitiesService = {
  get,
  post,
  put,
  delete: _delete,
  checkStatus,
  changeStatus,
  getProgressReport,
  getStructureReport
};